export type EmailErrorType =
    | 'invalid'
    | 'permanent_unavailable'
    | 'blocked'
    | 'complained'
    | 'unsubscribed'
    | 'temporary_unavailable';

export const EMAIL_ERROR_DESCRIPTIONS: Record<EmailErrorType, string> = {
    invalid: 'Адрес не существует или введён неправильно',
    permanent_unavailable: 'Постоянная недоступность адреса',
    blocked: 'Блокировка адреса администрацией Unisender Go',
    complained: 'Жалоба на спам',
    unsubscribed: 'Адрес отписался',
    temporary_unavailable: 'Временная недоступность адреса',
};